import styled, { css } from 'styled-components';

export const ArticleWrapper = styled.div`
  height: 100%;
  a {
    text-decoration: none !important;
    display: block;
    height: 100%;
    border-bottom: 1em solid transparent;
  }
`;

export const imageBlock = css`
  object-fit: cover;
  object-position: 50% 50%;
  width: 100%;
  max-width: 100%;
  margin: 0;
  height: 200px;
`;

export const focalPointImageStyle = css`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  margin: 0;
  height: 200px;
`;

export const TextBlock = styled.div`
  position: relative;
  padding: 20px 35px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-height: 100%;
  overflow: hidden;
  > p {
    margin: 10px 0 0 0;
  }
  @media only screen and (max-width: 794px) {
    padding: 20px 2.25rem;
  }
`;

export const HeaderText = styled.div`
  margin: 0px;
  svg {
    stroke: var(--red);
    margin-left: 5px;
    height: 0.6em;
    padding-top: 2px;
  }
`;

export const ChevronNewLine = styled.span`
  white-space: nowrap;
`;

export const TagsBarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
  flex-wrap: wrap;
  font-size: 0.9rem;
  span {
    display: inline-block;
    margin: 0 8px;
    color: #646464;
  }
  p {
    display: inline-block;
    margin: 0;
  }
`;

export const bgWhite = css`
  background: var(--white);
`;

export const bgAbbey = css`
  background: var(--gallery);
`;
